import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMG, SERVICES } from "../data/site";
import { PageHero, CTASection } from "../components/Sections";
import { useLanguage, usePath } from "../i18n/LanguageContext";

const Services = () => {
  const { t } = useLanguage();
  const p = usePath();

  return (
    <main data-testid="services-page">
      <PageHero
        overline={t.servicesPage.overline}
        title={t.servicesPage.title}
        intro={t.servicesPage.intro}
        img={IMG.forklift}
      />

      <section className="bg-[#FDFBF7] grain relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 lg:py-24 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s) => {
            const tr = { ...t.services[s.slug], ...t.servicesCardOverrides?.[s.slug] };
            return (
              <article
                key={s.slug}
                id={s.slug}
                data-testid={`services-card-${s.slug}`}
                className="group bg-white border border-slate-200 overflow-hidden hover:border-amber-600 transition-colors flex flex-col scroll-mt-28"
              >
                <div className="h-48 overflow-hidden">
                  <img
                    src={s.img}
                    alt={tr.title}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-7 flex flex-col flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="h-9 w-9 bg-slate-950 flex items-center justify-center shrink-0 group-hover:bg-amber-600 transition-colors">
                      <s.icon className="h-4 w-4 text-amber-500 group-hover:text-white transition-colors" />
                    </span>
                    <h2 className="font-heading text-xl font-bold tracking-tight text-slate-900">{tr.title}</h2>
                  </div>
                  <p className="text-sm text-slate-600 leading-relaxed flex-1">{tr.long}</p>
                  <Link
                    to={p(`/contact?service=${s.slug}`)}
                    data-testid={`services-card-${s.slug}-quote-button`}
                    className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-amber-700 hover:text-amber-800 transition-colors"
                  >
                    {t.home.requestQuote} <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
                  </Link>
                </div>
              </article>
            );
          })}
        </div>
      </section>

      <CTASection />
    </main>
  );
};

export default Services;
